var map = {
	"./22B730C1-FC9D-43B8-8701-44921004F016_1_105_c.jpeg": "./src/images/research/feedback/22B730C1-FC9D-43B8-8701-44921004F016_1_105_c.jpeg",
	"./4E590337-7878-4F7C-8E02-F4FD4AB094C1_1_105_c.jpeg": "./src/images/research/feedback/4E590337-7878-4F7C-8E02-F4FD4AB094C1_1_105_c.jpeg",
	"./5119764B-AA3F-4D08-B1D5-ABCA849D8B7E_1_105_c.jpeg": "./src/images/research/feedback/5119764B-AA3F-4D08-B1D5-ABCA849D8B7E_1_105_c.jpeg",
	"./54E6F359-F8EC-4AD8-9741-1634D9435D7E_1_105_c.jpeg": "./src/images/research/feedback/54E6F359-F8EC-4AD8-9741-1634D9435D7E_1_105_c.jpeg",
	"./628A5B86-FA19-4041-BCA0-3515B17784F5_1_105_c.jpeg": "./src/images/research/feedback/628A5B86-FA19-4041-BCA0-3515B17784F5_1_105_c.jpeg",
	"./707CEB0E-47D8-4480-9B6F-E65C9C538EE8_1_105_c.jpeg": "./src/images/research/feedback/707CEB0E-47D8-4480-9B6F-E65C9C538EE8_1_105_c.jpeg",
	"./7829BAC2-12DD-4A54-8756-89D15B34BB9A_1_105_c.jpeg": "./src/images/research/feedback/7829BAC2-12DD-4A54-8756-89D15B34BB9A_1_105_c.jpeg",
	"./82F16F1B-F419-45BB-81DF-00B60DF7F841_1_105_c.jpeg": "./src/images/research/feedback/82F16F1B-F419-45BB-81DF-00B60DF7F841_1_105_c.jpeg",
	"./83D34298-B11A-42EF-9B5C-D4E812E0F31D_1_105_c.jpeg": "./src/images/research/feedback/83D34298-B11A-42EF-9B5C-D4E812E0F31D_1_105_c.jpeg",
	"./8D38CCA7-823F-4200-84E6-47C90BFC69B3_1_105_c.jpeg": "./src/images/research/feedback/8D38CCA7-823F-4200-84E6-47C90BFC69B3_1_105_c.jpeg",
	"./943DB5B7-DD2D-4EB1-97CC-B066D0D0D136_1_102_o.jpeg": "./src/images/research/feedback/943DB5B7-DD2D-4EB1-97CC-B066D0D0D136_1_102_o.jpeg",
	"./9608FEA4-8562-4610-8B54-CCC372E65D66_1_105_c.jpeg": "./src/images/research/feedback/9608FEA4-8562-4610-8B54-CCC372E65D66_1_105_c.jpeg",
	"./98C94562-8369-4751-85D2-D160459195FE_1_105_c.jpeg": "./src/images/research/feedback/98C94562-8369-4751-85D2-D160459195FE_1_105_c.jpeg",
	"./A7537D81-57CD-4150-933D-6EED0A914DC2_1_105_c.jpeg": "./src/images/research/feedback/A7537D81-57CD-4150-933D-6EED0A914DC2_1_105_c.jpeg",
	"./B4693B00-01D3-412F-BF12-833E82A3E313_1_105_c.jpeg": "./src/images/research/feedback/B4693B00-01D3-412F-BF12-833E82A3E313_1_105_c.jpeg",
	"./D539BACC-BE5F-48BC-AF76-CF0EE67D7802_1_105_c.jpeg": "./src/images/research/feedback/D539BACC-BE5F-48BC-AF76-CF0EE67D7802_1_105_c.jpeg",
	"./D9D1D69F-FF54-434A-86A5-3624C08DEBDD_1_105_c.jpeg": "./src/images/research/feedback/D9D1D69F-FF54-434A-86A5-3624C08DEBDD_1_105_c.jpeg",
	"./E0DFD971-63C8-429C-8FC0-99ED0C2DC3EF_1_105_c.jpeg": "./src/images/research/feedback/E0DFD971-63C8-429C-8FC0-99ED0C2DC3EF_1_105_c.jpeg",
	"./E3AFB072-AC4E-4C06-9B8D-FC0D1668E8FD_1_105_c.jpeg": "./src/images/research/feedback/E3AFB072-AC4E-4C06-9B8D-FC0D1668E8FD_1_105_c.jpeg",
	"./F8D3CE08-22C6-486C-9C0D-2DE7C8E3A8EB_1_105_c.jpeg": "./src/images/research/feedback/F8D3CE08-22C6-486C-9C0D-2DE7C8E3A8EB_1_105_c.jpeg",
	"./FA580168-EDEC-4E1D-B1A7-A258297331D4_1_105_c.jpeg": "./src/images/research/feedback/FA580168-EDEC-4E1D-B1A7-A258297331D4_1_105_c.jpeg",
	"./IMG_2958.PNG.png": "./src/images/research/feedback/IMG_2958.PNG.png",
	"./unnamed (13).jpeg": "./src/images/research/feedback/unnamed (13).jpeg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/research/feedback sync \\.(png|jpe?g|svg)$";